<div *ngIf="!!application"
  class="apply-wrapper yc-layout">
  <div class="row mt-2">
    <div class="col-md-2">

      <!-- Client Logo-->
      <div class="logo-container">
        <img class="max-width-logo" 
          src="{{application.clientLogoUrl | gcAddStaticResourceSAS}}"
          [alt]="application.clientBranding.name + ' ' + ('BRAND:hdrLogo' | ycI18n: 'Logo')"/>
      </div>

      <!-- Instructions -->
      <div *ngIf="!!instructions"
        class="info-box">
        <div>
          <strong>
            <h2>
              <yc-i18n
                key="GLOBAL:INSTRUCTIONS"
                defaultValue="Instructions">
              </yc-i18n>
            </h2>     
          </strong>
          <div class="mt-2 mb-4">
            {{ instructions }}
          </div>
        </div>
      </div>

      <!-- Forms -->
      <div *ngIf="!isRouting && forms.length > 0"
        class="info-box">
        <div>
          <h2>
            <strong>
              <yc-i18n *ngIf="!isNomination"
                key="APPLY:textApplicationForms"
                defaultValue="Application Forms">
              </yc-i18n>
              <yc-i18n *ngIf="isNomination"
                key="APPLY:textNominationForms"
                defaultValue="Nomination Forms">
              </yc-i18n>
            </strong>
          </h2>       
          <div class="d-flex flex-column mt-3 mb-4">
            <div *ngFor="let form of forms">
              <div class="d-flex flex-column">
                <div class="d-flex">
                  <div>
                    <yc-fa
                      [icon]="form.applicationFormStatusId === FormStatuses.Submitted ? 'lock' : 'pencil'"
                      [light]="true"
                      [class.text-link]="form.applicationFormStatusId === FormStatuses.Submitted">
                    </yc-fa>
                  </div>
                  <div class="form-name">
                    <a *ngIf="+form.formId !== +formId"
                      class="break-word"
                      href="javascript:void(0)"
                      [ycTrackClick]="'Change form'"
                      (click)="changeFormAsync(form)">
                      {{ formTranslationMap[form.formId]?.Name || form.formName }}
                    </a>
                    <span *ngIf="+form.formId === +formId"
                      class="break-word">
                      {{ formTranslationMap[form.formId]?.Name || form.formName }}
                    </span>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="d-flex">
                    <yc-fa
                      [icon]="form.dueDate ?
                        'exclamation-circle' :
                        formStatusMap[form.applicationFormStatusId].icon"
                      [light]="true"
                      [ngClass]="form.dueDate ?
                        'text-warning' :
                        formStatusMap[form.applicationFormStatusId].iconClass"
                      class="me-2">
                    </yc-fa>
                    <ng-container>
                      <!-- Form Status -->
                      <yc-i18n *ngIf="!form.dueDate"
                        key="APPLY:textStatusOnDateDynamic"
                        [context]="{
                          status: formStatusMap[form.applicationFormStatusId].translated,
                          date: form | gcFormStatusDate
                        }"
                        defaultValue="__status__ on __date__">
                      </yc-i18n>
                      <!-- Form Due -->
                      <yc-i18n *ngIf="form.dueDate"
                        key="APPLY:textFormDueOn"
                        [context]="{
                          date: form.dueDate | ycFormDueDate
                        }"
                        defaultValue="Form due on __date__">
                      </yc-i18n>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Files -->
      <div *ngIf="files.length > 0" 
        class="info-box">
        <strong>
          <yc-i18n *ngIf="!isNomination"
            key="GLOBAL:hdrApplicationFiles"
            defaultValue="Application Files">
          </yc-i18n>
          <yc-i18n *ngIf="isNomination"
            key="GLOBAL:hdrNominationFiles"
            defaultValue="Nomination Files">
          </yc-i18n>
        </strong>
        <div class="d-flex flex-column mt-3 mb-4">
          <div *ngFor="let file of files">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <div>
                  <yc-fa
                    icon="paperclip"
                    [light]="true"
                    class="text-link">
                  </yc-fa>
                </div>
                <div class="file-name">
                  <a class="break-word"
                    href="javascript:void(0)"
                    [ycTrackClick]="'Open file'"
                    (click)="openFile(file)">
                    {{ file.fileName }}
                  </a>
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex">
                  <yc-fa
                    icon="file-alt"
                    [light]="true"
                    class="me-2 text-link">
                  </yc-fa>
                  <yc-i18n
                    key="GLOBAL:textFileAddedDate"
                    [context]="{
                      date: file.uploadedDate | gcStartOfDayDateFormatter
                    }"
                    defaultValue="File added __date__">
                  </yc-i18n>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Awards -->
      <div *ngIf="awards.length > 0"
        class="info-box">
        <strong>
          <yc-i18n
            key="common:hdrApplicationAward"
            defaultValue="Application Award">
          </yc-i18n>
        </strong>
        <div class="d-flex flex-column mt-3 mb-4">
          <div class="mb-3">
            {{ awardTotalText }}
          </div>
          <yc-button
            [link]="true"
            [langKey]="'common:textClickToViewMoreDetail'"
            [defaultText]="'Click to view more detail'"
            (onClick)="viewAwards()">
          </yc-button>
        </div>
      </div>
    </div>



    <!-- Form Header -->
    <div class="col-md-10 col-md-offset-2">
      <div class="form-container text-center">
        <h1 class="form-header yc-header">
          {{ currentFormName }}
        </h1>
        <div class="form-header-desc">
          <span>
            {{ currentFormDescription }}
          </span>
        </div>
      </div>

      <!-- Form Alert -->
      <div *ngIf="!!formAlert">
        <gc-form-alerts
          [formAlerts]="[formAlert]"
          [hideFormAction]="true"
          [hideProgram]="true"
          [hideForm]="true"
          [hideAppId]="true"
          [alertHeaderText]="'APPLY:textFormPastDue' | ycI18n:  'Form past due'">
        </gc-form-alerts>
      </div>
  
      <!-- Revision Alert -->
      <div *ngIf="showForm &&
        application.form &&
        application.form.revisionNotes &&
        application.statusId === ApplicationStatuses.Hold"
        class="form-revision-box">
        <div class="mb-2 font-550 font-875-rem d-flex">
          <yc-fa
            [icon]="'exclamation-circle'"
            class="text-warning me-2">
          </yc-fa>
          <div class="d-flex">
            <yc-i18n
              key="GLOBAL:REVISION_REQUESTED"
              defaultValue="Revision Requested">
            </yc-i18n>
            <div *ngIf="!!application.form.dueDate">
              &nbsp;
              (<yc-i18n 
                key="APPLY:textFormDueOn"
                [context]="{
                  date: application.form.dueDate | ycFormDueDate
                }"
                defaultValue="Form due on __date__">
              </yc-i18n>)
            </div>
          </div>
        </div>
        <span>
          <span [innerHTML]="application.form.revisionNotes | escapeHtml"></span>
        </span>
      </div>

    <!-- Applicant Info -->
    <gc-applicant-info-panel *ngIf="!isRouting"
      [applicationId]="applicationId"
      [clientId]="application.clientId"
      [clientName]="application.clientName"
      [allowCollaboration]="application.programAllowCollaboration &&
        (
          !acceptingNewSubmissions ?
            application.statusId !== ApplicationStatuses.Draft :
            true
        )"
      [applicant]="{
        id: applicant.id,
        firstName: applicant.firstName,
        lastName: applicant.lastName,
        email: applicant.email,
        addressString: applicantAddressString,
        canManageApplicants: false,
        canReceiveEmails: false,
        isApplicationOwner: true,
        phoneNumber: applicant.phoneNumber
      }"
      [organization]="hideSelectOrg || !selectedOrg ? null : ({
        name: selectedOrg?.document.name,
        id: selectedOrg?.document.id ? +selectedOrg.document.id : null,
        guid: selectedOrg?.document?.nonprofitGuid,
        image: selectedOrg?.document.iconURL,
        addressString: selectedOrg?.document.addressString,
        identification: selectedOrg?.document.registrationId,
        isPrivateOrg: selectedOrg?.document.isPrivateOrg,
        canUpdate: !!application.applicationId &&
        !revisionRequested &&
        !application.invitationOrganizationId &&
          isApplicationDraft &&
          (isNomination || !application.nominationApplicationId),
        eligibleForGivingStatusId: selectedOrg?.document.eligibleForGivingStatusId,
        parentGuid: selectedOrg?.document.parentGuid,
        parentName: selectedOrg?.document.parentName,
        address: selectedOrg?.addressObj,
        isInternational: selectedOrg?.document.isInternational,
        registrationAuthorityName: '',
        phone: selectedOrg?.document.phone
      })"
      [forNomination]="isNomination"
      (onUpdateOrg)="showSelectOrgModal(true)">
    </gc-applicant-info-panel>

      <!-- Custom form -->
      <div class="form-container">
        <div class="form-container-title d-flex justify-content-between">
          <!-- Form Questions Header -->
          <div>
            <h2>
              <yc-i18n
              [key]="showEligibilityForm ?
                'APPLY:textEligibilityFormQuestions' :
                'APPLY:textFormQuestions'"
              [defaultValue]="showEligibilityForm ?
                'ELIGIBILITY FORM QUESTIONS' :
                'FORM QUESTIONS'">
            </yc-i18n>
            </h2>         
          </div>
          <!-- Download Application -->
          <yc-button *ngIf="showForm && !isRouting"
            [link]="true"
            [fontAwesomeIcon]="'download'"
            [langKey]="'common:textDownload'"
            [defaultText]="'Download'"
            (onClick)="downloadPDF(false)">
          </yc-button>
        </div>
        <div class="mb-3">
          <div *ngIf="!isRouting &&
            acceptingNewSubmissions &&
            (showForm && application.form?.canEdit) ||
            (showEligibilityForm)">
            <yc-i18n
              key="APPLY:textCompleteRequiredFields"
              defaultValue="Complete the required fields below.">
            </yc-i18n>
          </div>
          <div *ngIf="showForm &&
            !application.form?.canEdit &&
            !application.isArchived">
            <yc-i18n
              key="APPLY:CANT_EDIT_FORM"
              defaultValue="This form has been submitted and cannot be edited.">
            </yc-i18n>
          </div>
          <div *ngIf="application.isArchived">
            <yc-fa icon="warning" class="text-danger me-2"></yc-fa>
            <yc-i18n
              key="APPLY.textApplicationIsArchived"
              defaultValue="This application has been archived and cannot be edited."
              class="text-danger">
            </yc-i18n>
          </div>
          <div *ngIf="!isRouting && !revisionRequested &&
            (isApplicationDraft || showEligibilityForm) &&
            application.statusId === ApplicationStatuses.Draft">
            <div [ngClass]="acceptingNewSubmissions ? 'text-success' : 'text-danger'"
              class="me-1">
              {{ programAcceptanceText }}
            </div>
          </div>
        </div>

        <!-- Nomination Form Header -->
        <gc-nomination-form-header *ngIf="isNomination"
          [forApplicant]="true"
          [forOrg]="application.programApplicantType === ProgramApplicantType.ORGS"
          [nomination]="nominationForm"
          [readOnly]="!canEditForm"
          [markForValidity]="markForValidity"
          (onValidityChange)="onNomineeValidityChange($event)"
          (formChanged)="nominationFormChanged($event)">
        </gc-nomination-form-header>
      
        <div class="row">
          <div *ngIf="application"
            class="col-sm-12">
          
            <gc-form-renderer *ngIf="showForm"
              [formType]="application.form?.formType"
              [applicationId]="applicationId"
              [applicationFormId]="application.applicationFormId"
              [formId]="application.form?.formId"
              [formRevisionId]="application.form?.formRevisionId"
              [programId]="application.programId"
              [form]="application.form?.formDefinition"
              [externalFields]="application"
              [getSavedSignature]="getSavedSignature"
              [requireSignature]="application.form?.requireSignature"
              [signatureDescription]="application.form?.signatureDescription"
              [supportsBypassSignature]="false"
              [disableSubmitButton]="callMaker?.loading"
              [readOnly]="!canEditForm"
              [orgId]="orgId"
              [notAutoSave]="isRouting"
              (onChange)="onChange([$event])"
              (submit)="isRouting ?  submitRouting() : submitForm($event)"
              (onConditionalVisibilityStateChanged)="conditionalVisibilityState = $event"
              (onTranslationsReady)="translations = $event.translations;
                richTextTranslations = $event.richTextTranslations;">
            </gc-form-renderer>

            <gc-form-renderer *ngIf="showEligibilityForm"
              [formType]="application.eligibilityForm?.formType"
              [form]="application.eligibilityForm?.formDefinition"
              [externalFields]="application"
              [formId]="application.eligibilityForm?.formId"
              [formRevisionId]="application.eligibilityForm?.formRevisionId"
              [programId]="application.programId"
              [readOnly]="!canEditForm"
              [disableSubmitButton]="callMaker?.loading"
              (onChange)="onChange([$event])"
              (submit)="saveEligibility()">
            </gc-form-renderer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<yc-status-floater *ngIf="statusText"
  class="d-none d-md-inline"
  [statusText]="statusText"
  [statusIcon]="statusIcon"
  [statusColor]="'primary'">
</yc-status-floater>
